<header class="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
  <div class="flex h-16 items-center justify-between gap-4 px-4 sm:px-6">
    <div class="flex items-center gap-3">
      <button
        type="button"
        class="inline-flex h-10 w-10 items-center justify-center rounded-xl border border-slate-200 text-slate-700 transition hover:bg-slate-100 lg:hidden"
        (click)="menuClick.emit()"
        aria-label="Open menu"
      >
        ☰
      </button>

      <div>
        <div class="text-lg font-semibold text-slate-900">
          {{ pageTitle() }}
        </div>
        <div class="text-xs text-slate-500">
          {{ pageSubtitle() }}
        </div>
      </div>
    </div>

    <div class="flex items-center gap-3">
      <div class="hidden text-right sm:block">
        <div class="text-sm font-medium text-slate-800">
          {{ fullName() || 'User' }}
        </div>
        <div class="text-xs capitalize text-slate-500">
          {{ roleLabel() || 'Role' }}
        </div>
      </div>

      <a
        [routerLink]="profileRoute()"
        class="flex h-10 w-10 items-center justify-center rounded-full bg-slate-200 text-sm font-semibold text-slate-700 transition hover:bg-slate-300"
        aria-label="Open user profile"
        title="Open profile"
      >
        {{ initials() }}
      </a>
    </div>
  </div>
</header>